import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PostalRegistrationList from './components/PostalRegistrationList';

const { Cell } = ResponsiveGrid;

const PostalRegistration = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="郵務登記"
        // description="行事曆列表"
        breadcrumbs={[
          {
            name: '郵件包裹',
          },
          {
            name: '郵務登記',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PostalRegistrationList />
    </Cell>
  </ResponsiveGrid>
);

export default PostalRegistration;
